exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-menu {\n  font-size: 200%;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  visibility: hidden;\n  right: 8px;\n}\n\n.dropdown-menu li {\n  list-style: none;\n  float: none;\n  display: inline;\n}\n\n.dropdown-menu li a, .dropdown-menu li label {\n  display: block;\n  text-decoration: none;\n  white-space: nowrap;\n  width: auto;\n  background: #BBBBBB;\n  color: #24313C;\n  padding: 2px 10px;\n}\n\n.dropdown-menu li a:hover {\n  background: #EEEEFF;\n}\n", ""]);

// exports
